{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "moduleId": "forge",
  "features": [
    {
      "id": "byom",
      "name": "Bring Your Own Module",
      "summary": "Organization-specific capabilities inside aviOS.",
      "availability": "AVAILABLE"
    },
    {
      "id": "co-build",
      "name": "Co-Build",
      "summary": "Build new intelligence with Ironfleet.",
      "availability": "AVAILABLE"
    },
    {
      "id": "ironfleet-network",
      "name": "Ironfleet Network",
      "summary": "Partner AI agents, expertise, and data services.",
      "availability": "AVAILABLE"
    },
    {
      "id": "integrations",
      "name": "Integrations",
      "summary": "Connect existing systems.",
      "availability": "AVAILABLE"
    },
    {
      "id": "workflow-extensions",
      "name": "Workflow Extensions",
      "summary": "Adapt workflows to your procedures.",
      "availability": "AVAILABLE"
    },
    {
      "id": "data-migration",
      "name": "Data Migration",
      "summary": "Bring historical data in.",
      "availability": "AVAILABLE"
    }
  ]
}